module.exports = __webpack_public_path__ + "img/issues-red.2ce790d5.svg";